import { TZDateMini } from '@date-fns/tz';
import { format } from 'date-fns';
import * as React from 'react';

type Props = {
  noLabel?: boolean;
};

const CurrentHQTime = ({ noLabel = false }: Props) => {
  const [time, setTime] = React.useState<string>('');

  React.useEffect(() => {
    const updateTime = () => {
      const tzDate = new TZDateMini(new Date(), 'America/New_York');
      setTime(format(tzDate, 'hh:mm a'));
    };

    updateTime();

    const interval = setInterval(updateTime, 1000 * 60); // Update every minute
    return () => clearInterval(interval); // Cleanup interval on unmount
  }, []);

  if (noLabel) {
    return <span>{time}</span>;
  }

  return <span>Current time at our headquarters — {time}</span>;
};

export default CurrentHQTime;
